const addSortedClass = (sortBy, criteria) => sortBy === criteria ? 'sorted' : 'sort-by'
export default addSortedClass
